/**
 * Wildlife Form Configuration
 * Default values and configuration for wildlife report forms
 */

import { todayLocalDateString } from '../utils/dateHelpers';

export const WILDLIFE_FORM_DEFAULT_VALUES = {
  // Company and administrative info
  company_name: 'Eagle Pass Heliskiing',
  tenure_number: '3410026',

  // Date and surveyor
  date: todayLocalDateString(), // Today's date
  surveyor_name: '',
  
  // Species and observation
  species: '',
  animal_count: null,
  
  // Location data
  selectedZones: [],
  utm_zone: '',
  utm_e: '',
  utm_n: '',
  legacy_coordinates: '',
  elevation: null,
  
  // Observation details
  comments: '',
  animal_distance: '',
  aspect_of_animal: '',
  animal_reaction: '',
  immediate_action: '',
  end_of_day_action: '',
  inventory_method: '',
  ski_run: '',
  
  // Track and machine data
  num_of_animal_tracks: null,
  type_of_machine: '',
  snowmobile_observed: false,
  snowmobile_track_observed: false,
  
  // Trip group association
  tripgroupid: null,
  runid: null,
  observerid: null
};

export const FORM_VALIDATION_RULES = {
  required_fields: [
    'company_name',
    'tenure_number', 
    'date',
    'species'
  ],
  
  conditional_required: {
    // If species is not "No Observation", at least one zone must be selected
    zones_for_observation: {
      condition: (formData) => formData.species !== 'No Observation',
      field: 'selectedZones',
      rule: (zones) => zones && zones.length > 0,
      message: 'At least one zone must be selected for wildlife observations'
    },
    
    // If animal count is specified, it should be positive
    positive_animal_count: {
      condition: (formData) => formData.animal_count !== null && formData.animal_count !== '',
      field: 'animal_count',
      rule: (count) => count > 0,
      message: 'Animal count must be a positive number'
    }
  },
  
  field_limits: {
    animal_count: { min: 0, max: 1000 },
    elevation: { min: 0, max: 5000 },
    num_of_animal_tracks: { min: 0, max: 1000 }
  }
};

export const FORM_FIELD_PLACEHOLDERS = {
  surveyor_name: 'Enter surveyor name',
  animal_count: 'Number of animals observed',
  utm_e: 'UTM Easting coordinate',
  utm_n: 'UTM Northing coordinate', 
  legacy_coordinates: 'Legacy coordinate format',
  elevation: 'Elevation in meters',
  comments: 'Additional observations or notes',
  ski_run: 'Name of ski run or area',
  num_of_animal_tracks: 'Number of tracks observed'
};

export const FORM_HELP_TEXT = {
  species: 'Select "No Observation" if no wildlife was observed during the trip',
  zones: 'Select all zones where wildlife was observed. Multiple zones allowed for "No Observation" reports.',
  utm_coordinates: 'Use GPS coordinates in UTM format. Leave blank if unknown.',
  elevation: 'Approximate elevation where wildlife was observed',
  animal_reaction: 'How did the animal(s) react to the helicopter or human presence?',
  immediate_action: 'What action was taken immediately upon observing the wildlife?',
  end_of_day_action: 'Any follow-up actions taken at the end of the day?'
};
